const currentUser = (state = {}, action) => {
    switch(action.type){
        case "SET_LEAD":
            return {
                ...state,
                user: action.payload
            }
        default:
            return state
    }
}

export default currentUser;